import React from 'react';
import { Globe, Zap, Settings, DollarSign, Shield, Users, Package, Wrench, CheckCircle, Hammer } from 'lucide-react';
import { whyChooseUs, expertiseHighlights, qualityFeatures } from '../data/mock';

const iconMap = {
  Globe: Globe,
  Zap: Zap,
  Settings: Settings,
  DollarSign: DollarSign,
  Shield: Shield,
  Users: Users,
  Package: Package,
  Wrench: Wrench,
  CheckCircle: CheckCircle,
  Hammer: Hammer
};

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-24">
          {/* Left content */}
          <div className="space-y-8">
            <div>
              <span className="text-primary font-semibold text-sm uppercase tracking-wider">
                À propos de SESAM
              </span>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
                Votre partenaire de confiance en publicité extérieure
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                SESAM est le leader de l'installation et de la gestion d'espaces publicitaires en Afrique centrale 
                et de l'ouest. Avec plus de 15 années d'expérience, nous accompagnons les entreprises, ONG et 
                organisations dans le déploiement de campagnes publicitaires percutantes.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Notre expertise couvre l'ensemble du cycle de vie de vos campagnes : de la sélection des 
                emplacements stratégiques à l'installation et la maintenance de panneaux de haute qualité. 
                Présents dans 3 pays, nous offrons une couverture régionale unique.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 pt-8">
              <div className="bg-gradient-to-br from-cyan-50 to-blue-50 p-6 rounded-xl">
                <div className="text-4xl font-bold text-primary mb-2">100+</div>
                <div className="text-gray-700 font-medium">Panneaux installés</div>
              </div>
              <div className="bg-gradient-to-br from-cyan-50 to-blue-50 p-6 rounded-xl">
                <div className="text-4xl font-bold text-primary mb-2">200+</div>
                <div className="text-gray-700 font-medium">Clients satisfaits</div>
              </div>
            </div>
          </div>

          {/* Right content - Why choose us */}
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900 mb-8">
              Pourquoi choisir SESAM ?
            </h3>
            
            <div className="grid gap-6">
              {whyChooseUs.map((item) => {
                const Icon = iconMap[item.icon];
                return (
                  <div
                    key={item.id}
                    className="group bg-white border-2 border-gray-100 rounded-xl p-6 hover:border-primary transition-all hover:shadow-lg"
                  >
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 bg-gradient-to-br from-primary to-cyan-600 text-white p-3 rounded-lg group-hover:scale-110 transition-transform">
                        <Icon size={24} aria-hidden="true" />
                      </div>
                      <div>
                        <h4 className="text-xl font-bold text-gray-900 mb-2">
                          {item.title}
                        </h4>
                        <p className="text-gray-600">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Notre Savoir-faire Section */}
        <div className="mt-32">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="text-primary font-semibold text-sm uppercase tracking-wider">
              Notre Excellence
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
              Savoir-faire & Qualité Garantie
            </h2>
            <p className="text-xl text-gray-600">
              De l'importation des matériaux à l'installation finale, nous contrôlons chaque étape 
              pour vous garantir des panneaux publicitaires fiables et durables.
            </p>
          </div>

          {/* Expertise Highlights */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {expertiseHighlights.map((item) => {
              const Icon = iconMap[item.icon];
              return (
                <div
                  key={item.id}
                  className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl p-6 hover:shadow-xl transition-all"
                >
                  <div className="bg-primary text-white p-4 rounded-lg w-fit mb-4">
                    <Icon size={28} aria-hidden="true" />
                  </div>
                  <h4 className="text-lg font-bold text-gray-900 mb-3">
                    {item.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
